document.addEventListener("DOMContentLoaded", function () {
    const packNumberEl = document.querySelector("h3 span[pack-number]");
    const itemNumberEl = document.querySelector("h3 span[item-number]");
    const oneTimeLabels = document.querySelectorAll(".product-form-block .time-option");
    const addButton = document.querySelector(".bundle-add-to-cart");
    const mobileClick = document.querySelector(".bundle-builder__form");
    let bundleTotalPrice = 0;
    
    // Initialize pack number on page load
    initializePackNumber();
    
    document.addEventListener("click", function (e) {
        const btn = e.target.closest(".btn__wrapper");
        if (btn) {
            e.preventDefault();
            handleAddButton(btn);
            return;
        }
        const plusBtn = e.target.closest(".quantity_pop .plus");
        if (plusBtn) {
            e.preventDefault();
            handlePlusButton(plusBtn);
            return;
        }
        const minusBtn = e.target.closest(".quantity_pop .minus");
        if (minusBtn) {
            e.preventDefault();
            handleMinusButton(minusBtn);
            return;
        }
        const removeBtn = e.target.closest(".bundle-builder__item-remove");
        if (removeBtn) {
            handleRemoveButton(removeBtn);
            return;
        }
    });
    
    const packInputs = document.querySelectorAll('.bundle-pack-size input[name="product-option"]');
    packInputs.forEach(input => {
        input.addEventListener('change', function () {
            handlePackSizeChange(this);
        });
    });
    
    function initializePackNumber() {
        const activePackSize = document.querySelector('.bundles-sizes.is-active');
        if (activePackSize) {
            const packText = activePackSize.getAttribute('data-pack-size');
            const packSize = extractPackNumber(packText);
            updatePackNumber(packSize);
        }
    }
    
    function extractPackNumber(packText) {
        // Extract number from text like "2-Pack", "3-Pack", "4-Pack", "5-Pack"
        const match = packText.match(/(\d+)/);
        return match ? parseInt(match[1]) : 3;
    }
    
    function handleAddButton(btn) {
        const productId = btn.getAttribute("product-id");
        const productPrice = parseFloat(btn.getAttribute("product-price")) || 0;
        const cardInfo = btn.closest(".card__information");
        const qtyBox = cardInfo.querySelector(".quantity_pop");
        const slot = activateNextBundleSlot(productId, productPrice);
        if (slot) {
            btn.style.display = "none";
            qtyBox.style.display = "";
            qtyBox.classList.add('active');
            updateItemNumber();
            updateTotalPrice();
            updateTimeOptionVisibility();
        }
    }
    
    function handlePlusButton(plusBtn) {
        const productId = plusBtn.getAttribute("product-id");
        const productPrice = parseFloat(plusBtn.getAttribute("product-price")) || 0;
        const emptySlot = getNextEmptyBundleSlot(productId);
        if (!emptySlot) {
            plusBtn.classList.add('disabled');
            return;
        }
        activateNextBundleSlot(productId, productPrice);
        updateItemNumber();
        updateTotalPrice();
        updateTimeOptionVisibility();
    }
    
    function handleMinusButton(minusBtn) {
        const qtyBox = minusBtn.closest(".quantity_pop");
        const qtyInput = qtyBox.querySelector("input");
        const cardInfo = minusBtn.closest(".card__information");
        const addBtn = cardInfo.querySelector(".btn__wrapper");
        const productId = addBtn.getAttribute("product-id");
        removeLastBundlePreview(productId);
        if (countActiveProductSlots(productId) === 0) {
            qtyInput.value = 1;
            qtyBox.style.display = "none";
            qtyBox.classList.remove('active');
            addBtn.style.display = "";
        }
        updateItemNumber();
        updateTotalPrice();
        updateTimeOptionVisibility();
    }
    
    function handleRemoveButton(removeBtn) {
        const item = removeBtn.closest(".bundle-builder__item");
        const productId = removeBtn.getAttribute("product-id");
        const preview = item.querySelector(`.bundle-builder__preview[bundle-preview="${productId}"].active`);
        const imgContainer = item.querySelector(".item-img");
        if (preview) preview.classList.remove("active");
        if (imgContainer) imgContainer.style.display = "";
        item.classList.remove("active");
        updateProductQuantityUI(productId);
        updateGlobalButtons();
        updateItemNumber();
        updateTotalPrice();
        updateTimeOptionVisibility();
    }
    
    function handlePackSizeChange(input) {
        const activePackSize = input.closest('.bundles-sizes');
        const packText = activePackSize.getAttribute('data-pack-size');
        const selectedValue = extractPackNumber(packText);
        
        document.querySelectorAll('.bundles-sizes')
            .forEach(bs => bs.classList.remove('is-active'));
        activePackSize.classList.add('is-active');
        
        const itemsContainer = document.querySelector('.bundle-builder__items');
        const itemTemplate = itemsContainer.querySelector('.bundle-builder__item');
        const currentItems = itemsContainer.querySelectorAll('.bundle-builder__item').length;
        
        // Remove extra items when downsizing
        if (selectedValue < currentItems) {
            const itemsToRemove = currentItems - selectedValue;
            
            for (let i = 0; i < itemsToRemove; i++) {
                const lastChild = itemsContainer.lastElementChild;
                if (!lastChild) continue;
                
                // Click remove button if item is active
                const removeBtn = lastChild.querySelector(".bundle-builder__item-remove");
                if (removeBtn && lastChild.classList.contains('active')) {
                    removeBtn.click();
                }
                
                // Remove the element from DOM
                lastChild.remove();
            }
            
            // Update UI after all removals
            updateGlobalButtons();
            updateItemNumber();
            updateTotalPrice();
            updateTimeOptionVisibility();
        }
        
        // Add items when upsizing
        if (selectedValue > currentItems) {
            const toAdd = selectedValue - currentItems;
            
            for (let i = 0; i < toAdd; i++) {
                const clone = itemTemplate.cloneNode(true);
                clone.classList.remove("active");
                clone.querySelectorAll(".bundle-builder__preview")
                    .forEach(pre => pre.classList.remove("active"));
                
                const img = clone.querySelector(".item-img");
                if (img) img.style.display = "";
                
                const removeBtn = clone.querySelector(".bundle-builder__item-remove");
                if (removeBtn) removeBtn.removeAttribute("product-id");
                
                itemsContainer.appendChild(clone);
            }
        }
        
        updatePackNumber(selectedValue);
        updateGlobalButtons();
        updateItemNumber();
        updateTotalPrice();
        updateTimeOptionVisibility();
    }
    
    function getBundleItems() {
        return document.querySelectorAll(".bundle-builder__item");
    }
    
    function getNextEmptyBundleSlot(productId) {
        const items = getBundleItems();
        for (let item of items) {
            if (!item.classList.contains("active")) {
                const preview = item.querySelector(`[bundle-preview="${productId}"]`);
                if (preview) return item;
            }
        }
        return null;
    }
    
    function activateNextBundleSlot(productId, productPrice) {
        const slot = getNextEmptyBundleSlot(productId);
        if (!slot) return null;
        const img = slot.querySelector(".item-img");
        const preview = slot.querySelector(`[bundle-preview="${productId}"]`);
        const removeBtn = slot.querySelector(".bundle-builder__item-remove");
        if (img) img.style.display = "none";
        if (preview) preview.classList.add("active");
        if (removeBtn) {
            removeBtn.setAttribute("product-id", productId);
            removeBtn.setAttribute("product-price", productPrice);
        }
        slot.classList.add("active");
        bundleTotalPrice += productPrice;
        updateGlobalButtons();
        return slot;
    }
    
    function removeLastBundlePreview(productId) {
        const items = [...getBundleItems()].reverse();
        for (let item of items) {
            const preview = item.querySelector(`.bundle-builder__preview[bundle-preview="${productId}"].active`);
            if (preview) {
                preview.classList.remove("active");
                item.classList.remove("active");
                item.querySelector(".item-img").style.display = "";
                updateGlobalButtons();
                return true;
            }
        }
        return false;
    }
    
    function countActiveProductSlots(productId) {
        let count = 0;
        document.querySelectorAll(".bundle-builder__item").forEach(item => {
            const preview = item.querySelector(`.bundle-builder__preview[bundle-preview="${productId}"].active`);
            if (preview) count++;
        });
        return count;
    }
    
    function updateProductQuantityUI(productId) {
        const card = document.querySelector(`.btn__wrapper[product-id="${productId}"]`)?.closest(".card__information");
        if (!card) return;
        const qtyBox = card.querySelector(".quantity_pop");
        const qtyInput = qtyBox.querySelector("input");
        const addBtn = card.querySelector(".btn__wrapper");
        const activeCount = countActiveProductSlots(productId);
        if (activeCount === 0) {
            qtyInput.value = 1;
            qtyBox.style.display = "none";
            qtyBox.classList.remove('active');
            addBtn.style.display = "";
        } else {
            qtyInput.value = activeCount;
            qtyBox.classList.add('active');
        }
    }
    
    function updateGlobalButtons() {
        const allItems = [...document.querySelectorAll(".bundle-builder__item")];
        const allActive = allItems.every(item => item.classList.contains("active"));
        document.querySelectorAll(".btn__wrapper").forEach(btn => {
            btn.disabled = allActive;
            btn.classList.toggle("disabled", allActive);
        });
        document.querySelectorAll(".quantity_pop .plus").forEach(plus => {
            plus.disabled = allActive;
            plus.classList.toggle("disabled", allActive);
        });
    }
    
    function updatePackNumber(newPack) {
        if (packNumberEl) packNumberEl.innerText = newPack;
    }
    
    function updateItemNumber() {
        const activeItems = document.querySelectorAll(".bundle-builder__item.active").length;
        if (itemNumberEl) itemNumberEl.innerText = activeItems;
    }
    
    // Function to extract discount percentage from pack_badge text and convert to decimal
    function getDiscountRate() {
        const activePackSize = document.querySelector('.bundles-sizes.is-active');
        if (!activePackSize) return 0;
        
        const packBadge = activePackSize.querySelector('.pack_badge');
        if (!packBadge) return 0;
        
        const badgeText = packBadge.textContent.trim();
        
        // Extract number from text like "Save 17%" or "Save 21%"
        const match = badgeText.match(/(\d+)%/);
        if (match && match[1]) {
            // Convert percentage to decimal (e.g., "17" becomes 0.17)
            return parseInt(match[1]) / 100;
        }
        
        return 0;
    }
    
    function getCurrentPackSize() {
        const allItems = document.querySelectorAll(".bundle-builder__item");
        return allItems.length;
    }
    
    function updateTotalPrice() {
        let newTotal = 0;
        document.querySelectorAll(".bundle-builder__item.active").forEach(item => {
            const removeBtn = item.querySelector(".bundle-builder__item-remove");
            const productPrice = parseFloat(removeBtn?.getAttribute("product-price")) || 0;
            newTotal += productPrice;
        });
        bundleTotalPrice = newTotal;
        
        // Get discount rate dynamically from pack_badge
        const discountRate = getDiscountRate();
        const discountAmount = bundleTotalPrice * discountRate;
        const discountedPrice = bundleTotalPrice - discountAmount;
        
        // oneTimeLabels.forEach(label => {
        //     if (discountRate > 0) {
        //         label.innerHTML = `
        //         <span style="font-weight: bold; text-decoration: line-through;" id="discount-price">{discountedPrice.toFixed(2)}</span>
        //         <span style="margin-right: 8px;" id="total-price">₪{bundleTotalPrice.toFixed(2)}</span>
        //         `;
        //     } else {
        //         label.innerHTML = `$${bundleTotalPrice.toFixed(2)}`;
        //     }
        // });
        oneTimeLabels.forEach(label => {
            if (discountRate > 0) {
                // <span style="font-weight: bold;text-decoration: line-through;" class="discount-price" id="discount-price">${discountedPrice.toFixed(2)} ₪</span>
                label.innerHTML = `
                <span style="margin-right: 8px;" id="total-price">${bundleTotalPrice.toFixed(2)} ₪</span>
                `;
            } else {
                label.innerHTML = `${bundleTotalPrice.toFixed(2)} ₪`;
            }
        });
    }
    
    function updateTimeOptionVisibility() {
        if (!oneTimeLabels && !addButton && !mobileClick) return;
        const allItems = [...document.querySelectorAll(".bundle-builder__item")];
        const allActive = allItems.every(item => item.classList.contains("active"));
        if (allActive) {
            addButton.classList.remove('disabled');
            oneTimeLabels.forEach(label => label.classList.add('show'));
            mobileClick.classList.add('active');
        } else {
            addButton.classList.add('disabled');
            oneTimeLabels.forEach(label => label.classList.remove('show'));
            mobileClick.classList.remove('active');
        }
    }
});

document.addEventListener('click', async function (event) {
  const target = event.target.matches('.bundle-add-to-cart')
    ? event.target
    : event.target.closest('.bundle-add-to-cart');
  if (!target) return;
  event.preventDefault();

  if (target.classList.contains('loading')) {
    return;
  }
  
  target.classList.add("loading");
  
  const selectedPackElement = document.querySelector('.bundles-sizes.is-active');
  const selectedPackSize = selectedPackElement?.querySelector('.bundle-btn')?.textContent?.trim();
  const uniquePrefix = selectedPackElement?.dataset.uniquePrefix || 'Pack';
  
  // The Unique ID groups a bundle's lines in the cart (removing one line removes
  // the whole bundle), so it must not collide with a bundle already in the cart.
  const usedIds = await fetch('/cart.js')
    .then(res => res.json())
    .then(cart => new Set(cart.items.map(item => item.properties?.['Unique ID']).filter(Boolean)))
    .catch(() => new Set());
  let bundleUniqueId;
  do {
    bundleUniqueId = `${uniquePrefix}-${Math.floor(Math.random() * 9000) + 1000}`;
  } while (usedIds.has(bundleUniqueId));
  
  console.log('🆔 Generated Unique ID:', bundleUniqueId);
  
  const selectedItems = document.querySelectorAll('.bundle-builder__items .bundle-builder__item.active');
  const itemsMap = {};

  selectedItems.forEach(item => {
    const selectedOption = item.querySelector('.bundle-builder__preview.active');
    const variantId = selectedOption?.getAttribute('variant-id');

    if (!variantId) return;

    if (!itemsMap[variantId]) {
      itemsMap[variantId] = {
        variantId,
        quantity: 1,
        uniqueId: bundleUniqueId,
        packSize: selectedPackSize,
        prefix: uniquePrefix
      };
    } else {
      itemsMap[variantId].quantity += 1;
    }
  });
  const itemsData = Object.values(itemsMap);
  console.log('itemsData',itemsData)
  
  if (itemsData.length) {
    await window.AddAlltoCartDrawer(itemsData, target);
  } else {
    target.classList.remove("loading");
  }
});
window.AddAlltoCartDrawer = function (itemsData, buttonElement) {
  if (!itemsData.length) {
    buttonElement?.classList.remove("loading");
    return;
  }
  const formData = new FormData();
    itemsData.forEach((item, index) => {
    formData.append(`items[${index}][id]`, item.variantId);
    formData.append(`items[${index}][quantity]`, item.quantity);
    if (item.packSize) {
      formData.append(`items[${index}][properties][Pack Size]`, item.packSize);
    }
    if (item.uniqueId) {
      formData.append(`items[${index}][properties][Unique ID]`, item.uniqueId);
    }
  });
  console.log('itemsData', itemsData);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
    .then(() => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;
    return fetch(`/?sections=cart-drawer,cart-icon-bubble`)
      .then(res => res.json())
      .then(sections => {
        const drawerInner = cartDrawer.querySelector('.drawer__inner');
        if (drawerInner && sections['cart-drawer']) {
          drawerInner.innerHTML = new DOMParser()
            .parseFromString(sections['cart-drawer'], 'text/html')
            .querySelector('.drawer__inner').innerHTML;
        }
        const bubble = document.querySelector('.cart-count-section');
        if (bubble && sections['cart-icon-bubble']) {
          bubble.innerHTML = new DOMParser()
            .parseFromString(sections['cart-icon-bubble'], 'text/html')
            .querySelector('.cart-count-section').innerHTML;
        }
        cartDrawer.classList.remove('is-empty');
        cartDrawer.classList.add('active');
        cartDrawer.open();
      });
  }).then(() => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && cartDrawer.open) {
      cartDrawer.open();
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
  })
  .catch(err => {
    console.error(err);
    alert('Failed to add bundle to cart');
  })
  .finally(() => {
    buttonElement?.classList.remove("loading");
  });
};